import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "sonner";

// Components
import { Navigation } from "./components/Navigation";
import { HeroSection } from "./components/HeroSection";
import { LogisticsSection } from "./components/LogisticsSection";
import { MaterialsSection } from "./components/MaterialsSection";
import { VehicleSlider } from "./components/VehicleSlider";
import { OnboardingSection } from "./components/OnboardingSection";
import { Footer } from "./components/Footer";

// Pages
import SupportPage from "./pages/SupportPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import RefundPolicy from "./pages/RefundPolicy";
import AboutUs from "./pages/AboutUs";
import DosDonts from "./pages/DosDonts";
import CareerPage from "./pages/CareerPage";
import SellerPortal from "./pages/SellerPortal";
import DeliveryPartner from "./pages/DeliveryPartner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CENTRAL_HUB_API_URL = process.env.REACT_APP_CENTRAL_HUB_API_URL || BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const SUPPORT_API = `${CENTRAL_HUB_API_URL}/api`;

// Home Page Component
const HomePage = ({ onSellerSubmit, onPartnerSubmit }) => {
  return (
    <>
      <HeroSection />
      <LogisticsSection />
      <VehicleSlider />
      <MaterialsSection />
      <OnboardingSection 
        onSellerSubmit={onSellerSubmit}
        onPartnerSubmit={onPartnerSubmit}
      />
    </>
  );
};

function App() {

  const handleContactSubmit = async (formData) => {
    try {
      const response = await axios.post(`${SUPPORT_API}/support/general`, formData);
      toast.success(response.data.message);
      return { success: true };
    } catch (error) {
      toast.error("Failed to send message. Please try again.");
      return { success: false };
    }
  };

  const handleSellerOnboarding = async (formData) => {
    try {
      const response = await axios.post(`${API}/onboarding/seller`, formData);
      toast.success(response.data.message);
      return { success: true };
    } catch (error) {
      toast.error("Failed to submit. Please try again.");
      return { success: false };
    }
  };

  const handleSupplierSupport = async (formData) => {
    try {
      const response = await axios.post(`${SUPPORT_API}/support/supplier`, formData);
      toast.success(response.data.message);
      return { success: true };
    } catch (error) {
      toast.error("Failed to submit supplier request. Please try again.");
      return { success: false };
    }
  };

  const handleDeliveryPartnerSupport = async (formData) => {
    try {
      const response = await axios.post(`${SUPPORT_API}/support/delivery-partner`, formData);
      toast.success(response.data.message);
      return { success: true };
    } catch (error) {
      toast.error("Failed to submit delivery partner request. Please try again.");
      return { success: false };
    }
  };

  const handlePartnerOnboarding = async (formData) => {
    try {
      const response = await axios.post(`${API}/onboarding/partner`, formData);
      toast.success(response.data.message);
      return { success: true };
    } catch (error) {
      toast.error("Failed to submit. Please try again.");
      return { success: false };
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Navigation />
        <main>
          <Routes>
            <Route 
              path="/" 
              element={
                <HomePage 
                  onSellerSubmit={handleSellerOnboarding}
                  onPartnerSubmit={handlePartnerOnboarding}
                />
              } 
            />
            <Route 
              path="/support" 
              element={<SupportPage />} 
            />
            <Route
              path="/seller-portal"
              element={<SellerPortal onSubmit={handleSupplierSupport} />}
            />
            <Route
              path="/delivery-partner"
              element={<DeliveryPartner onSubmit={handleDeliveryPartnerSupport} />}
            />
            <Route 
              path="/privacy-policy" 
              element={<PrivacyPolicy />} 
            />
            <Route 
              path="/terms-conditions" 
              element={<TermsConditions />} 
            />
            <Route 
              path="/refund-policy" 
              element={<RefundPolicy />} 
            />
            <Route 
              path="/about-us" 
              element={<AboutUs />} 
            />
            <Route 
              path="/dos-donts" 
              element={<DosDonts />} 
            />
            <Route 
              path="/career" 
              element={<CareerPage />} 
            />
            <Route 
              path="/contact" 
              element={<ContactPage onSubmit={handleContactSubmit} />} 
            />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
